import { environment } from '@/shared/consts/environment'

export interface ISubscription {
  id: string
  userId: string
  externalId: string
  customerId: string
  affiliateId?: string
  provider: SubscriptionProviders
  createdOn: number
  updatedOn: number
  paymentId?: string
  subscriptionId?: string
  priceId?: SubscriptionProductIds
  active: boolean
}

export enum SubscriptionProviders {
  FREEBIRD = 'freebird',
  STRIPE = 'stripe',
}

// typescript has a problem with variables as enums
export enum SubscriptionProductIds {
  // @ts-ignore
  INSIDER_LIFETIME = environment.stripeProductInsiderLifetime,
  // @ts-ignore
  INSIDER_MONTHLY = environment.stripeProductInsiderMonthly,
  // @ts-ignore
  INSIDER_YEARLY = environment.stripeProductInsiderYearly,
  // @ts-ignore
  INSIDER_PRO_MONTHLY = environment.stripeProductInsiderProMonthly,
  // @ts-ignore
  INSIDER_PRO_YEARLY = environment.stripeProductInsiderProYearly,
  FREEBIRD = 'freebird',
}

export enum SubscriptionProductNames {
  INSIDER_LIFETIME = 'insider_lifetime',
  INSIDER_MONTHLY = 'insider_monthly',
  INSIDER_YEARLY = 'insider_yearly',
  INSIDER_PRO_MONTHLY = 'insider_pro_monthly',
  INSIDER_PRO_YEARLY = 'insider_pro_yearly',
  FREEBIRD = 'freebird',
  ENTERPRISE_MONTHLY = 'enterprise_monthly',
  ENTERPRISE_YEARLY = 'enterprise_yearly',
}

export enum SubscriptionCouponIds {
  // @ts-ignore
  INSIDER_YEARLY = environment.stripeCouponInsiderYearly,
  // @ts-ignore
  INSIDER_MONTHLY = environment.stripeCouponInsiderMonthly,
}
